import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import ConnectNav from './ConnectNav';
import NotificationsBell from './NotificationsBell';
import './styles/ConnectFeed.css';

/** The Community App header, mobile menu and main column. */
export default function ConnectShell({ active, onLogout, children }) {
  const [showMobileNav, setShowMobileNav] = useState(false);

  return (
    <div className="feed-page">
      <header className="connect-profile-header">
        <Link to="/" className="connect-profile-logo">
          <img src={process.env.PUBLIC_URL + '/assets/logo.png'} alt="OutCaribbean" />
        </Link>
        <ConnectNav active={active} />
        <div className="connect-header-actions">
          <NotificationsBell />
          <button className="connect-logout-btn" onClick={onLogout}>Log Out</button>
          <button className="connect-mobile-nav-toggle" onClick={() => setShowMobileNav(true)}>
            <span></span><span></span><span></span>
          </button>
        </div>
      </header>

      {showMobileNav && (
        <>
          <div className="connect-mobile-nav-overlay active" onClick={() => setShowMobileNav(false)}></div>
          <div className="connect-mobile-nav-menu active">
            <div className="connect-mobile-nav-header">
              <h3>Menu</h3>
              <button className="connect-mobile-nav-close" onClick={() => setShowMobileNav(false)}>×</button>
            </div>
            <div className="connect-mobile-nav-links">
              <ConnectNav active={active} variant="mobile" onNavigate={() => setShowMobileNav(false)} />
            </div>
            <div className="connect-mobile-nav-footer">
              <Link to="/community-guidelines" className="connect-guidelines-link">
                Community Guidelines
              </Link>
              <button className="connect-logout-btn" onClick={onLogout}>Log Out</button>
            </div>
          </div>
        </>
      )}

      <main className="feed-main">{children}</main>
    </div>
  );
}
